export default __webpack_public_path__ + "static/media/4-stepRes.c834e8d9.png";